import React, { useState, useEffect } from 'react';
import ChevronDown from '../../assets/icons/common/chevron-down.svg';
import ChevronUp from '../../assets/icons/common/chevron-up-active.svg';

function MenuItem({ item, selected, handleClickEvent, isSidebarOpen }) {
  const { id, label, path, icon: IconComponent, submenu } = item;
  const hasSubmenu = !!submenu;
  
  const [isOpen, setIsOpen] = useState(() => {
    return localStorage.getItem(`${id}IsOpen`) === 'true';
  });

  useEffect(() => {
    if (hasSubmenu) {
      localStorage.setItem(`${id}IsOpen`, isOpen);
    }
  }, [isOpen, id, hasSubmenu]);

  // Add this function to check if any submenu item is selected
  const isSubmenuItemSelected = () => {
    if (!submenu) return false;
    return Object.values(submenu).some(subItem => subItem.path === selected);
  };

  const toggleSubmenu = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const isCollapsed = !isSidebarOpen;
  const isActive = hasSubmenu 
    ? isSubmenuItemSelected() 
    : selected === path;

  const renderSubmenu = () => {
    if (!submenu || isCollapsed) return null;

    return (
      <ul className={`nav flex-column submenu ${isOpen ? 'active' : ''}`}>
        {Object.values(submenu).map((subItem) => (
          <li key={subItem.id} className="nav-item subitem">
            <div
              id={subItem.id}
              className={`nav-link sublink ${selected === subItem.path ? 'active' : ''}`}
              onClick={(e) => handleClickEvent(e, subItem.path)}
            >
              <span className="menu-text align-text-bottom text-nowrap">
                {subItem.label}
              </span>
            </div>
          </li>
        ))}
      </ul>
    );
  };

  const navLink = (
    <div
      id={id}
      className={`nav-link ${isCollapsed ? 'collapsed' : ''} ${hasSubmenu ? 'has-submenu' : ''} ${isActive ? 'active' : ''}`}
      onClick={hasSubmenu ? toggleSubmenu : (e) => handleClickEvent(e, path)}
    >
      <IconComponent className="sidebar-icon" />
      {!isCollapsed && (
        <>
          <span className="menu-text align-text-bottom text-nowrap">{label}</span>
          {hasSubmenu && (
            <img
              src={isOpen ? ChevronUp : ChevronDown}
              alt={isOpen ? 'Collapse' : 'Expand'}
              className="chevron-icon"
            />
          )}
        </>
      )}
    </div>
  );

  return (
    <li className="nav-item">
      <div className={`menu-container ${hasSubmenu && isOpen ? 'submenu-active' : ''}`}>
        {navLink}
        {renderSubmenu()}
      </div>
    </li>
  );
}

export default MenuItem;